import { BuildPlanPayload, Recipe } from '../pages/types';

export const buildBuildPlanPayload = ({
  planSizeId,
  recipes,
  recipeIds,
  accountId,
  frequency,
}: {
  planSizeId: string;
  recipes?: Recipe[];
  recipeIds?: string[];
  accountId: string;
  frequency?: number | null;
}): BuildPlanPayload => {
  const ids = recipeIds ?? recipes?.map((recipe) => recipe.id) ?? [];
  const payload: BuildPlanPayload = {
    discounts: [],
    plan_size: planSizeId,
    recipes: ids,
    account_id: accountId,
  };
  if (frequency !== undefined && frequency !== null) {
    payload.frequency = frequency;
  }
  return payload;
};
